import type { HealthServiceSchema } from '@libs/data-access/entities'
import type {
  PaginatedQueryResponse,
  UseAppQueryOptions
} from '@libs/data-access/queries'
import { appQueryClient } from '@libs/data-access/queries'

import type { FetchPaginatedHealthServicesOptions } from '../healthServices.api'
import { fetchPaginatedHealthServices } from '../healthServices.api'
import { healthServicesCacheKeys } from '../healthServices.cacheKeys'

export const getHealthServices = (
  request: FetchPaginatedHealthServicesOptions,
  queryOptions?: UseAppQueryOptions<PaginatedQueryResponse<HealthServiceSchema>>
) => {
  return appQueryClient.fetchQuery({
    ...queryOptions,
    queryKey: healthServicesCacheKeys.allHealthServices(request?.queryParams),
    queryFn: () =>
      fetchPaginatedHealthServices(
        request || { queryParams: { search_name: '' } }
      )
  })
}
